import { SVGProps, Ref, forwardRef } from 'react';

import hoc from '@hh.ru/magritte-ui-icon/hoc';

const ChevronRightOutlinedSize24Component = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.2729 11.9996L9.27295 19.9995L8.00017 18.7267L14.7273 11.9996L8.00017 5.2726L9.27295 3.9998L17.2729 11.9996Z"
                fill="var(--magritte-ui-icon-color)"
            />
        </g>
    </svg>
);
const ChevronRightOutlinedSize24 = hoc<'ChevronRightOutlinedSize24'>(
    forwardRef(ChevronRightOutlinedSize24Component),
    'ChevronRightOutlinedSize24'
);
export default ChevronRightOutlinedSize24;
